// extracted by mini-css-extract-plugin
export default {"container":"fC4LTrUlvKGPxrLxe0oE"};